var map = {
	"./wdwd.item.quantity.update.json": 524,
	"./wdwd.items.inventory.get.json": 525,
	"./wdwd.items.onsale.get.json": 526,
	"./wdwd.logistics.companies.get.json": 527,
	"./wdwd.logistics.offline.send.json": 528,
	"./wdwd.logistics.offline.update.json": 529,
	"./wdwd.product.quantity.update.json": 530,
	"./wdwd.skus.custom.get.json": 531,
	"./wdwd.trade.close.json": 532,
	"./wdwd.trade.fullinfo.get.json": 533,
	"./wdwd.trade.memo.update.json": 534,
	"./wdwd.trades.sold.get.json": 535,
	"./wdwd.trades.sold.increment.get.json": 536
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 702;



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/api \.\/wdwd\..+\.json$
 ** module id = 702
 ** module chunks = 1
 **/